<!-- eslint-disable vue/valid-v-for -->
<!-- eslint-disable vue/require-component-is -->
<template>
  <div class="oms-header">
    <div>
      <template v-for="(item) in this.businessHeader.left">
        <component :is="item" />
      </template>
    </div>
    <div style="display: flex;align-items: center;justify-content: end">
      <template v-for="(item) in this.businessHeader.right">
        <component :is="item" />
      </template>

      <!-- <ClearCache /> -->
      <SignOut @eventsClick="eventsClick" />
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import Msg from './children/Msg/index.vue';
import Work from './children/Work.vue';
import Knowledge from './children/Knowledge.vue';
import TenantSwitch from './children/TenantSwitch.vue';
import SignOut from './children/SignOut.vue';
// import MqttClient from '../utils/MqttClient';
import Baseunified from '../utils/micro/baseunified';
import CallBox from './children/CallBox.vue';
import ClearCache from './children/ClearCache.vue';

export default {
  name: 'OmsHeader',
  components: {
    Msg, Work, Knowledge, TenantSwitch, SignOut, CallBox, ClearCache,
  },
  data() {
    return {
      collapsed: false,
      headerModel: null,
      businessHeader: {
        left: [],
        right: [],
      },
    };
  },
  created() {
    this.headerModel = new Baseunified();
    this.businessHeader = this.headerModel.showHeaderModule();
  },
  methods: {
    eventsClick() {
      this.collapsed = !this.collapsed;
      this.$emit('onClick', this.collapsed);
      // eslint-disable-next-line no-undef
      mainBus.$emit('collapsed-click', this.collapsed);
    },
  },
};
</script>

<style lang="less" scoped>
.oms-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 600px;

  .msg-icon {
    font-size: 22px;
    color: #ffffff;
    padding: 19px;
  }
}
</style>
